import script from "./PwdSecurity1.vue?vue&type=script&lang=ts&setup=true"
export * from "./PwdSecurity1.vue?vue&type=script&lang=ts&setup=true"

import "./PwdSecurity1.vue?vue&type=style&index=0&id=12ce19b4&lang=scss"

const __exports__ = script;

export default __exports__